import type { Accept } from 'react-dropzone'

// extensions taken from invoice-delivery repo
// https://github.com/Zervant/invoice-delivery/blob/main/src/delivery/attachment/handler.clj
export const ACCEPTED_ATTACHMENT_MIME_EXTENSIONS: Accept = {
  // images
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
  'image/vnd.microsoft.icon': ['.ico'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/vnd.adobe.photoshop': ['.psd'],

  // documents
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/vnd.apple.pages': ['.pages'],
  'application/vnd.apple.numbers': ['.numbers'],

  // spreadsheets
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],

  // presentations
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],

  // archives / misc
  'application/zip': ['.zip'],
  'application/octet-stream': ['.dat'],
}
